import { useEffect, useState } from "react";
import ErrorModal from "@/components/modals/ErrorModal";
import { errorEvents } from "@/lib/error-events";

export function GlobalErrorModal() {
  const [isOpen, setIsOpen] = useState(false);
  const [errorConfig, setErrorConfig] = useState({ title: "", description: "" });

  useEffect(() => {
    const unsubscribe = errorEvents.subscribe(({ title, description }) => {
      setErrorConfig({ title: title || "Error", description });
      setIsOpen(true);
    });

    return () => unsubscribe();
  }, []);

  return (
    <ErrorModal
      isOpen={isOpen}
      onClose={() => setIsOpen(false)}
      title={errorConfig.title}
      description={errorConfig.description}
    />
  );
}
